import "./PropertyCleanup.module.css";
import Header from "@/reusable_sections/Header";
import WhatIsForestryMulching from "./sections/WhatIsForestryMulching";
import HowForestryMulchingWorks from "./sections/HowForestryMulchingWorks";
import BenefitsOfPropertyCleanup from "./sections/BenefitsOfPropertyCleanup";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import ReadyToTransformYourProperty from "./sections/ReadyToTransformYourProperty";
import Footer from "@/reusable_sections/Footer";
export default function PropertyCleanupPage() {
  return <div>
      <Header />
      <WhatIsForestryMulching />
      <HowForestryMulchingWorks />
      <BenefitsOfPropertyCleanup />
      <FrequentlyAskedQuestions />
      <ReadyToTransformYourProperty />
      <Footer />
    </div>;
}